var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3483_19081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66055 9.77294L1.64722 8.75961C1.23389 8.34628 1.23389 7.66628 1.64722 7.25294L2.66055 6.23961C2.83388 6.06628 2.97388 5.72627 2.97388 5.48627V4.05292C2.97388 3.46626 3.45389 2.98627 4.04055 2.98627H5.47388C5.71388 2.98627 6.05388 2.84629 6.22721 2.67296L7.24051 1.65961C7.65385 1.24628 8.33391 1.24628 8.74725 1.65961L9.76058 2.67296C9.93391 2.84629 10.2738 2.98627 10.5138 2.98627H11.9472C12.5339 2.98627 13.0138 3.46626 13.0138 4.05292V5.48627C13.0138 5.72627 13.1538 6.06628 13.3272 6.23961L14.3406 7.25294C14.7539 7.66628 14.7539 8.34628 14.3406 8.75961L13.3272 9.77294C13.1538 9.94628 13.0138 10.2863 13.0138 10.5263V11.9596C13.0138 12.5463 12.5339 13.0263 11.9472 13.0263H10.5138C10.2738 13.0263 9.93391 13.1663 9.76058 13.3396L8.74725 14.3529C8.33391 14.7663 7.65385 14.7663 7.24051 14.3529L6.22721 13.3396C6.05388 13.1663 5.71388 13.0263 5.47388 13.0263H4.04055C3.45389 13.0263 2.97388 12.5463 2.97388 11.9596V10.5263C2.97388 10.2797 2.83388 9.93961 2.66055 9.77294Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10L10 6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66302 9.66699H9.66902",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32965 6.33301H6.33564",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3483_19081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVoucher);
export default __webpack_public_path__ + "static/media/ic-voucher.fbec8b3417856f4dde70fc6ee60e965b.svg";
export { ForwardRef as ReactComponent };